import React from "react";
import { Paper, Typography, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { chunk, isEmpty } from "lodash";

import PageDomain from "../domain";
import PageConfig from "../config";
import TargetBreakDown from "./target-breakdown";
import DailySalesDataTable from "./daily-sales-data-table";

const { FULL_MONTH_NAME_FORMAT } = PageConfig;

const DailySalesTable = ({ orderedSalesMap }) => {
  const { salesForecastData } = useSelector((state) => state.genericDataV2);

  const currentMonthSalesData = PageDomain.generateDailySalesTable({
    orderedSalesMap,
  });

  const [table1, table2] = chunk(
    currentMonthSalesData,
    Math.ceil(currentMonthSalesData.length / 2)
  );

  const avgNextMonthNewAds = salesForecastData.avgNextMonthNewAds ?? 0;
  const avgNextMonthRenewAds = salesForecastData.avgNextMonthRenewAds ?? 0;

  const currentSalesMonth = PageDomain.getCurrentSalesMonthEndDate({
    format: FULL_MONTH_NAME_FORMAT,
  });

  return (
    <Paper elevation={2} className="chart-paper flex-col ">
      <Typography variant="h6">Daily Sales Table</Typography>
      <Typography variant="caption" className="text-capitalize">
        Month: {currentSalesMonth}
      </Typography>
      {!isEmpty(orderedSalesMap) && (
        <>
          <TargetBreakDown
            avgNextMonthNewAds={avgNextMonthNewAds}
            avgNextMonthRenewAds={avgNextMonthRenewAds}
          />
          <Grid container direction="row" className="flex-no-wrap p-8 gap-x-8 ">
            <DailySalesDataTable
              tableData={table1}
              avgNextMonthNewAds={avgNextMonthNewAds}
              avgNextMonthRenewAds={avgNextMonthRenewAds}
            />
            <DailySalesDataTable
              tableData={table2}
              avgNextMonthNewAds={avgNextMonthNewAds}
              avgNextMonthRenewAds={avgNextMonthRenewAds}
            />
          </Grid>
        </>
      )}
    </Paper>
  );
};

export default DailySalesTable;
